import { render, staticRenderFns } from "./ProductShowcaseMock.vue?vue&type=template&id=561569fa&scoped=true"
import script from "./ProductShowcaseMock.vue?vue&type=script&lang=js"
export * from "./ProductShowcaseMock.vue?vue&type=script&lang=js"
import style0 from "./ProductShowcaseMock.vue?vue&type=style&index=0&id=561569fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561569fa",
  null
  
)

export default component.exports